import { NgModule } from 'ng-metadata/core';
import {UserAreaService} from './userArea.service';
import {PrmAuthentication} from './authentication.directive';
import {AuthenticationService} from './authentication.service';
import {PrmLibraryCardMenu} from './libraryCard/libraryCardMenu.directive';
import {LibraryCardMenuService} from './libraryCard/libraryCardMenu.service';
import appConfigModule from '../../../appConfig/appConfig.module';
import {PrmUserArea} from './userArea.directive';
import {PrmUserAreaExpandable} from './userAreaExpandable.directive'
import {UserAreaExpandableService} from './userAreaExpandable.service'
import {LanguageSelectionService} from "./languageSelection/languageSelection.service";
import {PrmLanguageSelection} from "./languageSelection/languageSelection.directive";
import {RequestItBookmarkDirective} from './requestItBookmark/request-it-directive';

@NgModule({
    declarations: [
        PrmAuthentication,
        PrmLibraryCardMenu,
        PrmUserArea,
        PrmUserAreaExpandable,
        PrmLanguageSelection,
        RequestItBookmarkDirective
    ],
    providers: [
        AuthenticationService,
        LibraryCardMenuService,
        UserAreaService,
        UserAreaExpandableService,
        LanguageSelectionService
    ],
    imports:[
        appConfigModule.name,
        'primo-explore.security'
    ]
})
export class UserAreaModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/userArea.module.ts